module.exports = __webpack_public_path__ + "img/icon-youtube.00539ee1.svg";